<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Chọn ngày bạn muốn tìm kiếm"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="[12]"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/getAccountPartPoint/searchAllV7?sortField=status,id&"
            create-url="/getAccountPartPoint/save"
            delete-url="/getAccountPartPoint/delete"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="6"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Báo cáo số liệu L1 theo luồng",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      fromDate: null,
      toDate: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: 'dateStr',
          text: 'Date',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 8%;",
        },
        {
          value: 'year',
          text: 'Luồng',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countAllUserRegister',
          text: 'AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentYearAllUser',
          text: 'Luồng/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },

        {
          value: 'countClickStudy',
          text: 'ClickPart1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentClickStudy',
          text: 'ClickP1/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishStudy',
          text: 'FinishP1L1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishStudy',
          text: 'FinishP1/ClickP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF1All',
          text: 'FinishP1/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentDropStudy',
          text: 'DropStudy',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickListen',
          text: 'ClickPart2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishListen',
          text: 'FinishP2L1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishListen',
          text: 'FinishP2/ClickP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF2All',
          text: 'FinishP2/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentDropListen',
          text: 'DropListen',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickPractise',
          text: 'ClickPart3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishPractise',
          text: 'FinishP3L1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishPractise',
          text: 'FinishP3/ClickP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF3All',
          text: 'FinishP3/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentDropPractise',
          text: 'DropPractise',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
/*        {
          value: 'countCancelDownloadPart1',
          text: 'CancelDownP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentCancelDownloadPart1',
          text: 'ClickP1/CancelDownP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countCancelDownloadPart2',
          text: 'CancelDownP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentCancelDownloadPart2',
          text: 'ClickP2/CancelDownP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countCancelDownloadPart3',
          text: 'CancelDownP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentCancelDownloadPart3',
          text: 'ClickP3/CancelDownP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },*/
      ],
    };
  },

  created() {
  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
